<template>
    <div>
        <div class="publish-boxs com-model f-w m-b-15">{{btnArr[tabindex].txt}}</div>
        <div class="publish-boxs com-model m-b-15">
            <div class="box-title">招聘岗位信息</div>
            <div class="item">
                <div class="label">招聘类型</div>
                <div class="value">
                    <label class="lishlabel" :class="{'lishlabel-active':category*1 === 1}">
                        <input type="radio" value="1" v-model="category">
                        <span>全职</span>
                    </label>
                    <label class="lishlabel" :class="{'lishlabel-active':category*1 === 2}">
                        <input type="radio" value="2" v-model="category">
                        <span>兼职</span>
                    </label>
                </div>
            </div>
            <div class="item">
                <div class="label require">岗位名称</div>
                <div class="value input-box">
                    <input type="text" placeholder="请输入如：操作工，长工等职位" :maxlength="10"
                        v-model="title">
                </div>
            </div>
            <div class="item">
                <div class="label require">岗位类别</div>
                <div class="value one-input">
                    <el-cascader :placeholder="placeholdertxt"
                                :options="industryList" @active-item-change="handleItemChange"
                                @change="handleVal"></el-cascader>
                </div>
            </div>
            <div class="item flex-start" style="align-items: flex-start;">
                <div class="label require">岗位描述</div>
                <div class="value skil-box" style="width: 400px;">
                    <el-input
                        type="textarea"
                        placeholder="请填写500字以内的描述"
                        v-model="description" resize="none"
                        :maxlength="500"
                        style="height: 200px"
                    />
                    <div class="title-2">已选技能关键词</div>
                    <div class="tag-box">
                        <el-tag
                            :key="tag"
                            v-for="(tag, index) in skilList"
                            :closable="true"
                            type="primary"
                            @close="handleDelTag(index)"
                        >
                            {{tag}}
                        </el-tag>
                    </div>
                    <el-input ref="skilInputRef" v-model="currentAddSkil" placeholder="点击输入关键词回车确认" @change="handleChange" />
                    <template v-if="!currentAddSkil">
                        <template v-for="item in skilTree">
                            <div class="skil-title">{{ item.name }}</div>
                            <div class="skil-item">
                                <span v-for="(sk, i) in item.children" :key="i" @click="handleAddSkil(sk.name)">{{ sk.name }}</span>
                            </div>
                        </template>
                    </template>
                    <div class="skil-item" v-else>
                        <span v-for="(sk, i) in skilTree" :key="i" @click="handleAddSkil(sk.name)">{{ sk.name }}</span>
                    </div>
                    <!-- <div class="skil-title">硬件开发傻</div>
                    <div class="skil-item">
                        <span v-for="(sk, i) in skilOptions1" :key="i" @click="handleAddSkil(sk)">{{ sk }}</span>
                    </div>

                    <div class="skil-title">硬件开发卵</div>
                    <div class="skil-item">
                        <span v-for="(sk, i) in skilOptions1" :key="i" @click="handleAddSkil(sk)">{{ sk }}</span>
                    </div>

                    <div class="skil-title">硬件开发🫓</div>
                    <div class="skil-item">
                        <span v-for="(sk, i) in skilOptions1" :key="i" @click="handleAddSkil(sk)">{{ sk }}</span>
                    </div> -->
                </div>
                <!-- 智能推荐 -->
                <div class="new-recommend-box">
                    <img class="robote" src="../../assets/images//icon_robot.png" />
                    <div class="content-box">
                        <div>岗位职责</div>
                        <i v-if="aiReleast && title && allval.length && !postDesc" class="el-icon-loading"></i>
                        <div class="a-b" v-html="postDesc"></div>
                        <!-- <div>1、负责加工厂的日常进度管理满</div>
                        <div>2、负责生产质量管理嘴</div>
                        <div>3、负责日常人力资源调度跑</div>
                        <div>4、负责与供应商的关系维护火</div> -->
                        <div class="split-line"></div>
                        <div class="sub-tit">推荐的技能关键词</div>
                        <div class="label-item">
                            <i v-if="aiReleast && title && allval.length && !postSkils.length" class="el-icon-loading"></i>
                            <span v-for="item in postSkils">{{ item }}</span>
                            <!-- <span>质量管理车</span>
                            <span>人力资源</span>-->
                        </div>
                    </div>
                    <div class="btns-box">
                        <span class="refresh" @click="getPostInfo"><img src="../../assets//images/icon_refresh.png" />{{ btnText }}</span>
                        <span class="submit" @click="handleBatchAddSkil">直接填入</span>
                    </div>
                </div>
                <!-- <div class="recommend-box">
                    <div class="in-title">智能推荐</div>
                    <div class="text-area">
                    <el-input
                        type="textarea"
                        :value="recommend" resize="none" readonly>
                        </el-input>
                    </div>
                    <div class="button" @click="description = recommend">填入</div>
                </div> -->
            </div>
        </div>
        <div class="publish-boxs com-model m-b-15">
            <div class="box-title">岗位要求</div>
            <div class="item">
                <div class="label require">性别要求</div>
                <div class="value">
                    <label class="lishlabel" :class="{'lishlabel-active':requireSex*1 === -1}">
                        <input type="radio" value="-1" v-model="requireSex">
                        <span>不限</span>
                    </label>
                    <label class="lishlabel" :class="{'lishlabel-active':requireSex*1 === 1}">
                        <input type="radio" value="1" v-model="requireSex">
                        <span>男性</span>
                    </label>
                    <label class="lishlabel" :class="{'lishlabel-active':requireSex*1 === 0}">
                        <input type="radio" value="0" v-model="requireSex">
                        <span>女性</span>
                    </label>
                </div>
            </div>
            <div class="item">
                <div class="label require">年龄要求</div>
                <div class="value flex">
                    <div class="input-box" style="width: 128px">
                    <input v-model="requireMinage" type="text"
                       :maxlength="2" placeholder="请填写最小年龄要求">
                    </div>
                    <span style="margin: 0 8px">至</span>
                    <div class="input-box" style="width: 128px">
                    <input type="text" v-model="requireMaxage"
                        :maxlength="2" placeholder="请填写最大年龄要求">
                    </div>
                </div>

            </div>
            <div class="item">
                <div class="label require">学历要求</div>
                <div class="value">
                    <el-select v-model="requireEdu" placeholder="请学历">
                        <el-option
                        v-for="item in eduList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label require">经验要求</div>
                <div class="value">
                    <el-select v-model="requireExp" placeholder="请学历">
                        <el-option
                        v-for="item in expList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">身高</div>
                <div class="value input-box">
                    <input type="text" placeholder="请填写对候选人的身高要求" :maxlength="10"
                        v-model="requireHeight">
                </div>
            </div>
            <div class="item">
                <div class="label">形象</div>
                <div class="value input-box">
                    <input type="text" placeholder="请填写对候选人的形象要求" :maxlength="10"
                        v-model="requireImage">
                </div>
            </div>
            <div class="item">
                <div class="label">着装要求</div>
                <div class="value input-box">
                    <input type="text" placeholder="请填写对候选人的着装要求，如是否要穿工服" :maxlength="10"
                        v-model="requireClothing">
                </div>
            </div>
        </div>

        <div class="publish-boxs com-model">
            <div class="box-title">福利待遇<div class="sub">（以下福利是公司默认福利待遇，也可根据岗位在下面直接修改，不修改则默认当前设置）</div></div>
            <div class="item">
                <div class="label require mt0">薪资结构</div>
                <div class="value lishbtn-groups lishbtn-groupsa">
                    <div class="button" @click="workTypeSel(item)"
                            :class="{active:workType.indexOf(item) > -1 ? true :false}"
                            v-for="item in workTypeList">{{item}}
                    </div>
                </div>
                <div v-if="workTypeMore" class="errorTs" style="margin-left:0;">最多选择三个计酬方式</div>
            </div>
            <div class="item">
                <div class="label require">薪资范围</div>
                <div class="value flex">
                    <div class="input-box min">
                    <input :maxlength="6" type="text" placeholder="请填写最小薪资"
                       v-model="minSalary">
                    </div>
                    <span class="lishline"></span>
                    <div class="input-box min">
                    <input :maxlength="6" type="text" placeholder="请填写最大薪资"
                        v-model="maxSalary">
                    </div>
                    <span class="lishunit">元</span>
                </div>

            </div>
            <div class="item">
                <div class="label require">招聘人数</div>
                 <div class="input-box min">
                    <input type="text" :maxlength="4" placeholder="请输入整数数字"
                        v-model="recruitNumber">
                 </div>
                <span class="lishunit">人</span>
            </div>
            <div class="item">
                <div class="label require">工作时间</div>
                <el-time-select class="lishinp lishw144" style="border: none;"
                                v-model="workStartTime"
                                :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '24:00'
                  }"
                                size="large"
                                placeholder="上班时间">
                </el-time-select>
                <!--<input class="lishinp lishw144" type="text" placeholder="上班时间" v-model="workStartTime">-->
                <span class="lishline"></span>
                <el-time-select class="lishinp lishw144" style="border: none;"
                                v-model="workEndTime"
                                :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '24:00'
                  }"
                                size="large"
                                placeholder="下班时间">
                </el-time-select>
                <!--<input class="lishinp lishw144" type="text" placeholder="下班时间" v-model="workEndTime">-->
                <span class="lishunit" style="margin-right:8px;margin-left:20px;">共</span>
                <div class="input-box min">
                <input type="number" step="0.1" v-model="workHours">
                </div>
                <span class="lishunit">小时</span>
            </div>
            <div class="item">
                <div class="label require">月休天数</div>
                <div class="value flex">
                    <el-select v-model="dayOffLength" placeholder="请选择规模">
                        <el-option disabled style="color: #333333 !important;">请选择月休天数</el-option>
                        <el-option
                        v-for="item in 11"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                    <span class="lishunit">天</span>
                </div>
            </div>
            <div class="item">
                <div class="label require mt5">提供宿舍</div>
                <div class="lishbtn-groups">
                    <div class="button" @click="provideBedroomSel(1)"
                            :class="{active:this.provideBedroom*1 == 1}">提供宿舍
                    </div>
                    <div class="button" @click="provideBedroomSel(0)"
                            :class="{active:this.provideBedroom*1 == 0}">自行安排
                    </div>
                </div>
                <div class="lishcondition flex">
                    <label style="margin-right:20px;" :class="{'active' : provideRestsubsidy == 1 ? true :false}" v-if="provideBedroom == 1">
                        <input type="radio" v-model="provideRestsubsidy" value="1">
                        <span>包住</span>
                    </label>
                    <label :class="{'active' : provideRestsubsidy == 0}">
                        <input type="radio"  v-model="provideRestsubsidy" value="0">
                        <span>无补贴</span>
                    </label>
                    <label  v-if="provideBedroom==1" :class="{'active' : provideRestsubsidy == 3}">
                        <input type="radio" v-model="provideRestsubsidy" value="3">
                        <span>外住补贴</span>
                    </label>
                    <label  v-if="provideBedroom==0" :class="{'active' : provideRestsubsidy == 2}">
                        <input type="radio" v-model="provideRestsubsidy" value="2">
                        <span>住宿补贴</span>
                    </label>
                    <div class="lishcond-item-info" v-if="provideRestsubsidy*1 == 2">
                        <div class="input-box">
                        <input  type="text" v-model="restsubsidys.bufen">
                        </div>
                        <span>元</span>
                    </div>
                    <div class="lishcond-item-info" v-if="provideRestsubsidy*1 == 3">
                        <div class="input-box" >
                            <input  type="text" v-model="restsubsidys.waizhu">
                        </div>
                        <span>元</span>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="label require mt5">用餐情况</div>
                <div class="lishbtn-groups">
                    <div class="button" @click="provideDiningroomSel(1)"
                            :class="{active:provideDiningroom == 1}">食堂用餐
                    </div>
                    <div class="button" @click="provideDiningroomSel(0)"
                            :class="{active:provideDiningroom == 0}">自行安排
                    </div>
                </div>
                <div class="lishcondition flex">
                    <label style="margin-right:20px;" :class="{active:provideFood == 1}" v-if="provideDiningroom == 1">
                        <input type="radio" v-model="provideFood" value="1">
                        <span>包吃</span>
                    </label>
                    <label :class="{active:provideFood == 0}">
                        <input type="radio" v-model="provideFood" value="0">
                        <span>无补贴</span>
                    </label>
                    <label :class="{active:provideFood == 2}">
                        <input type="radio" v-model="provideFood" value="2">
                        <span>补贴</span>
                    </label>
                    <div class="lishcond-item-info" v-if="provideFood*1 == 2">
                        <div class="input-box">
                            <input type="text" v-model="foodsubsidy">
                        </div>
                        <span>元</span>
                    </div>
                </div>
            </div>
            <div class="item" style="align-items: flex-start;">
                <div class="label require mt0 mt00">福利待遇</div>
                <div class="value " style="display: block; flex: 1">
                    <div class="flex lishbtn-groups lishbtn-groups-ks">
                    <div class="button" @click="welfareSel(item)"
                            :class="{active:welfareSelList.indexOf(item) > -1 ? true : false}"
                            v-for="(item, index) in totalWelFareList" :key="index">{{item}}
                    </div>
                    </div>
                    <div class="lishadd flex">
                        <div class="input-box" style="width: 166px;margin-left: 0">
                            <input type="text" v-model="newWelfareName" :maxlength="5" placeholder="请输入文本">
                        </div>
                        <div class="primary-btn" @click="addWelfare">添加</div>
                        <span v-if="welfareMore" class="errorTs">最多只能选择4个福利待遇</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="publish-boxs com-model">
            <div class="item" style="display: flex; overflow: inherit">
                <div class="label">视频描述</div>
                <div class="upload" style="padding: 0" v-if="recruitVideo" @click='showVideo'>
                    <img :src="recruitVideo + '?vframe/jpg/offset/0'"/>
                    <svg class="show-icon" t="1698290929575"  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10880" width="50" height="50"><path d="M512 64C265.6 64 64 265.6 64 512s201.6 448 448 448 448-201.6 448-448S758.4 64 512 64zM691.2 544l-256 156.8C428.8 704 422.4 704 416 704c-6.4 0-9.6 0-16-3.2C390.4 694.4 384 684.8 384 672L384 352c0-12.8 6.4-22.4 16-28.8 9.6-6.4 22.4-6.4 32 0l256 166.4c9.6 6.4 16 16 16 28.8C704 528 700.8 540.8 691.2 544z" p-id="10881"></path></svg>
                    <div class="delete-btn" @click.stop="recruitVideo = ''">
                        <svg t="1698309963902" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1700" width="30" height="30"><path d="M505.6 28.16C246.912 28.16 37.12 237.952 37.12 496.64s209.792 468.48 468.48 468.48 468.48-209.792 468.48-468.48S764.288 28.16 505.6 28.16z m283.648 716.928L755.2 779.136c-13.952 13.952-36.736 13.952-50.688 0L506.752 581.248 308.864 779.136c-13.952 13.952-36.736 13.952-50.688 0l-34.048-34.048c-13.952-13.952-13.952-36.736 0-50.688L422.016 496.64 224.256 298.88c-14.08-13.952-14.08-36.736-0.128-50.688l34.048-34.048c13.952-13.952 36.736-13.952 50.688 0l197.76 197.76 197.76-197.76c13.952-13.952 36.736-13.952 50.688 0l34.048 34.048c14.08 13.952 14.08 36.736 0 50.688L591.36 496.64l197.888 197.76c13.952 13.952 13.952 36.736 0 50.688z" fill="#666666" p-id="1701"></path></svg>
                    </div>
                </div>
                <div class="upload" v-else>
                    <svg t="1698286063110" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9071" width="100" height="100"><path d="M524.8 64c4.693333 0 8.533333 3.84 8.533333 8.533333V490.666667h418.133334c4.693333 0 8.533333 3.84 8.533333 8.533333v46.933333a8.533333 8.533333 0 0 1-8.533333 8.533334H533.333333v418.133333a8.533333 8.533333 0 0 1-8.533333 8.533333h-46.933333a8.533333 8.533333 0 0 1-8.533334-8.533333V554.666667H51.2a8.533333 8.533333 0 0 1-8.533333-8.533334v-46.933333c0-4.693333 3.84-8.533333 8.533333-8.533333H469.333333V72.533333c0-4.693333 3.84-8.533333 8.533334-8.533333h46.933333z" fill="#ccc" p-id="9072"></path></svg>
                    <input @change="uploadVideo" class="userbox-file-inp" type="file" accept=”video/*”>
                </div>
            </div>
            <div class="item">
                <div class="label">发布人</div>
                <div class="value">
                    <div style="margin-right: 20px">
                    <el-select v-model="hrs" placeholder="请选择">
                        <el-option
                        v-for="item in hrList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.hrId + '-' + item.hrName">
                        </el-option>
                    </el-select>
                    </div>
                    <div style="width: 400px">发布者手机号码：{{hrPhone}}</div>
                </div>
            </div>
            <div class="item">
                <div class="label">平台代理补贴</div>
                <div class="value">
                <div class="lishswitch">
                    <input id="checked_1" type="checkbox" v-model="switchCheck" class="switch"/>
                    <label for="checked_1"></label>
                </div>
                <span class="lishunit">帮助企业代理发放招聘车补，如无需不必填写</span>
                </div>
            </div>
            <div class="item" v-if="switchCheck">
                <div class="label">面试车补</div>
                <div class="value">
                    <div class="input-box">
                        <input type="text" placeholder="请输入金额" v-model="carsubsidy">
                    </div>
                    <span class="lishunit">元/人</span>
                </div>
            </div>
            <div class="item">
                <div class="label">账户余额</div>
                <div class="value">
                    <div class="lishmoney" v-if="accountInfo">￥{{accountInfo.availableFunds}}</div>
                    <span class="lishunit" v-if="switchCheck">账户余额不能少于{{minaccount}}元</span>
                </div>
            </div>
            <div class="lishbottom clearfix">
                <div class="lishbttom-btns">
                    <div class="publish-stat-btna" @click="publish(false)">{{btnArr[tabindex].btn}}</div>
                    <div class="publish-stat-btnb" @click="publish(true)" v-if="tabindex == 0">暂不发布，帮我保存</div>
                </div>

            </div>
        </div>
        <el-dialog title="视频预览" :visible.sync="videoVisible">
            <video style="width: 100%; height: 100%" :src="recruitVideo"  v-if="recruitVideo && videoVisible" autoplay></video>
        </el-dialog>
    </div>
</template>
<script>
    import {Cascader, Message} from 'element-ui'
    import {ReleaseAjax,btnArr} from './release.js'
    const qs = require("qs");

    const AI_INFO = {

        pro: {
            url: 'https://aidev.zlznai.com/v1/completion-messages',
            auth: {
                desc: 'Bearer app-WqNhtFu9RDRozSq6LEZ3pjHc',
                keyword: 'Bearer app-oKlOsjKGwjrToKj4AWhii2Co'
            }
        },
        dev: {
            url: 'https://df-api.yifu-tech.com/dify/completion-messages',
            auth: {
                desc: 'Bearer app-kzk67FVywxv0iMz33Vqupit3',
                keyword: 'Bearer app-NlVp5TLDUnaXKfoFwjcOKSsn'
            }
        }
    }

    export default {
        data(){
            return {
                btnArr:btnArr,
                tabindex:0,
                cuid: 0,
                placeholdertxt: '请选择',
                category: 1,
                requireHeight: '',
                requireImage: '',
                requireClothing: '',
                title: '',//岗位名称
                industryList: [],//岗位arr
                industryIdIndex: '',
                classifyList: [], //岗位二级分类arr
                classifyIndex: '',
                positionList: [], // 岗位三级分类arr
                industryId: '', //行业id
                classifyId: '',
                switchCheck: 0,
                requireMinage: '',//最小年龄
                requireMaxage: '',// 最大年龄
                expList: [],//经验列表
                requireExp: -1,//ji
                eduList: [],
                requireEdu: -1,
                minSalary: '', //最小薪资
                maxSalary: '', // 最高薪资
                recruitNumber: '', //招聘人数
                welfareList: [], // 福利列表
                postWelFareList: [],
                welfareSelList: [], // 选择的福利待遇列表
                requireSex: -1,// 性别要求
                workStartTime: '',//上班时间
                workEndTime: '',//下班时间
                workHours: '',//工作时长
                dayOffLength: 1, //月休天数
                description: '', // 详细描述
                provideDiningroom: 1,// 有无餐厅
                carsubsidy: 0, // 路费补贴
                provideFood: 1, //用餐补贴类型
                foodsubsidy: 0, // 用餐补贴金额
                provideBedroom: 1, // 提供宿舍
                provideRestsubsidy: 1, // 住宿补贴类型
//                 restsubsidy:0, // 住宿补贴金额
                allval: [],
                workTypeList: ['按月', '保底', '计时', '计件', '提成'],
                workType: ['计时'],
                hrList: [], // hr列表
                hrs: -1, // hrid
                restsubsidys: {
                    bufen: 0,
                    waizhu: 0
                },
                accountInfo: null,
                newWelfareName: '',// 新添加的福利名称
                welfareMore:false,
                workTypeMore:false,
                recruitVideo: '',
                videoVisible: false,
                recommend: null, // 智能推荐
                skilList: [],
                skilTree: [],
                currentAddSkil: '',
                postDesc: null,
                aiReleast: false,
                postSkils: [],
                btnText: '立即生成',
                cDescription: '',
                skilOptions1: ['CAD制图', '数控机床', '汇编语言', 'PLC编程', '车床切削']
            }
        },
        created(){
            this.getLastInfo();
            this.getListIndustry();
            this.getListExperience();
            this.getListEducation();
            this.getWelfareList();
            this.getHrList();
            this.getAccountInfo();
            let cuid = this.$route.query.cuid;
            let tabindex = this.$route.query.tab*1;
            if (cuid) {
                this.cuid = cuid;
                if(tabindex == 1 || tabindex == 3){
                    this.tabindex = 2;
                }else{
                    this.tabindex = 1;
                }
                this.getInfo(cuid);
            }

            this.getSkillList()
        },
        // 检查不要随意直接修改url
        beforeRouteEnter(to,from,next){
            if(to.path === '/index/posts/edit'){
                let cuid = to.query.cuid,
                    tab = to.query.tab;
                if(cuid === undefined || tab === undefined || tab*1 > 3){
                    next(vm => {
                        vm.$router.back();
                    })
                }
                // window.location.reload();
            }
            next();
        },

        computed: {
            minaccount(){
                return this.carsubsidy * this.recruitNumber;
            },
            hrPhone () {
                return this.hrs == -1 ? null : this.hrList.find(item => item.hrId == this.hrs.split('-')[0]).hrPhone;
            },
            totalWelFareList() {
                return [...new Set([...this.postWelFareList, ...this.welfareList])].filter(f => f)
            }
        },
        watch: {
            allval (newVal) {
                // this.getPostInfo()
                console.log('newVal', newVal)
                const positionId = newVal[2].split('-')[0];
                this.axios.get(`/wapi/hr/recruit/${positionId}/getDesc`)
                    .then(res => {
                        if (res.status * 1 === 200) {
                            // 获取智能推荐
                            this.recommend = res.data || null
                        }
                    })
            },
            // 最小年龄要求
            requireMinage(newval, oldval){
                if(this.requireMinage) {
                    this.requireMinage = newval.toString().replace(/^[^1-9]{1}|\D/g, '')
                }
            },
            // 最小年龄要求
            requireMaxage(newval, oldval){
                this.requireMaxage = newval.toString().replace(/^[^1-9]{1}|\D/g,'')
            },
            minSalary(newval, oldval){
                this.minSalary = newval.toString().replace(/^[^1-9]{1}|\D/g,'')
            },
            maxSalary(newval, oldval){
                this.maxSalary = newval.toString().replace(/^[^1-9]{1}|\D/g,'')
            },
            recruitNumber(newval, oldval){
                this.recruitNumber = newval.toString().replace(/^[^1-9]{1}|\D/g,'')
            },
            // 共多少小时
            workHours(newval,oldval){
                if(newval){
                    if(newval.toString().indexOf('.') > -1){
                        //小数点保留一位小数
                        if(newval.toString().split('.')[1] && newval.toString().split('.')[1].length > 1){
                            this.workHours = Number(newval).toFixed(1)
                        }
                        //整数部分最多两位
                        if(newval.toString().split('.')[0] && newval.toString().split('.')[0].length > 2){
                            this.workHours = newval.toString().slice(0,2) + '.' +  newval.toString().split('.')[1]
                        }
                    }else{
                        this.workHours = newval.toString().slice(0,2)
                    }
                }

                //this.workHours = newval.toString().replace(/^[^1-9]{1}|\D/g, '')

            },
            industryId(newval, oldval){
                if (newval) {
                    this.industryIdIndex = this.industryList.findIndex(j => j.id === newval.split("-")[0] * 1);
                    this.getListClassify(newval.split("-")[0]);
                }
            },
            classifyId(newval, oldval){
                if (newval) {
                    this.classifyIndex = this.classifyList.findIndex(j => j.id === newval.split("-")[0] * 1);
                    this.getListPosition(newval.split("-")[0]);
                }
            },
            provideBedroom(newval,oldval){
                this.provideRestsubsidy = 0;
            },
            provideDiningroom(newval,oldval){
                this.provideFood = 0;
            }
        },
        methods: {
            //获取上次已经填过的 提供宿舍用餐情况这些
            getLastInfo(){
                ReleaseAjax('lately').then(res => {
                    if(res.data){
                        console.log('res-data', res.data)
                        let latelyInfo = res.data;
                        this.dayOffLength = latelyInfo.dayOffLength;
                        this.workStartTime = latelyInfo.workStartTime.split(' ')[1].substr(0,5)
                        this.workEndTime = latelyInfo.workEndTime.split(' ')[1].substr(0,5);
                        this.workHours = latelyInfo.workHours;
                        this.welfareSelList = latelyInfo.welfare.split(':');
                        this.postWelFareList = latelyInfo.welfare.split(':');
//                        this.provideCarsubsidy = latelyInfo.provideCarsubsidy;
                        this.provideDiningroom = latelyInfo.provideDiningroom;
                        this.provideRestsubsidy = latelyInfo.provideRestsubsidy;
                        this.provideBedroom = latelyInfo.provideBedroom;
                        this.foodsubsidy = latelyInfo.foodsubsidy;
                        this.provideFood = latelyInfo.provideFood;
                        if(this.provideBedroom){
                            this.restsubsidys.waizhu = latelyInfo.restsubsidy;
                        }else{
                            this.restsubsidys.bufen = latelyInfo.restsubsidy;
                        }


//                        this.latelyInfo = res.data;

                    }else{

                    }
                })
            },
            // 自定义添加福利
            addWelfare(){
                let url = `/wapi/company/addWelfare?name=${this.newWelfareName}`;
                this.axios.get(url).then(res => {
                    if (res.success) {
                        this.getWelfareList();
                    }
                })
            },
            getAccountInfo(){
                let url = `/wapi/company/getRemain`;
                this.axios.get(url).then(res => {
                    if (res.success) {
                        this.accountInfo = res.data;
                    }
                })
            },
            getInfo(id){
                this.axios.get(`/wapi/hr/recruit/get?recruitId=${id}`)
                    .then(res => {
                        let {data, msg, status, success} = res;
                        if (!success)
                            return;
                        console.log('getInfo', data)
                        this.title = data.title;
                        this.category = data.category;
                        this.description = data.description;
                        this.requireHeight = data.requireHeight;
                        this.requireImage = data.requireImage;
                        this.requireClothing = data.requireClothing;
                        this.skilList = data.keywords
                        this.minSalary = data.minSalary;
                        this.maxSalary = data.maxSalary;
                        this.workType = data.workType.split(':');
                        this.requireSex = data.requireSex;
                        this.requireMinage = data.requireMinage;
                        this.requireMaxage = data.requireMaxage;
                        this.requireEdu = data.requireEdu;
                        this.requireExp = data.requireExp;
                        this.welfareSelList = data.welfare ? data.welfare.split(':') : [];
                        this.postWelFareList = data.welfare ? data.welfare.split(':') : [];
                        this.dayOffLength = data.dayOffLength;
                        this.recruitNumber = data.recruitNumber;
                        this.workHours = data.workHours;
                        this.workStartTime = data.workStartTime.split(" ")[1]
                        this.workEndTime = data.workEndTime.split(" ")[1],
                            this.provideDiningroom = data.provideDiningroom;
                        this.provideFood = data.provideFood;
                        this.foodsubsidy = data.foodsubsidy;
                        this.provideBedroom = data.provideBedroom;
                        this.provideRestsubsidy = data.provideRestsubsidy;
                        this.restsubsidy = data.restsubsidy;
                        this.switchCheck = data.provideCarsubsidy;
                        this.carsubsidy = data.carsubsidy;
                        this.placeholdertxt = data.industryName + '/' + data.classifyName + '/' + data.positionName;
                        this.allval = [
                            data.industryId + '-' + data.industryName, data.classifyId + '-' + data.classifyName, data.positionId + '-' + data.positionName
                        ]
                        this.recruitVideo = data.videoUrl
                    })
            },
            getIndex(val, arr){
//                if(typeof arr != )
            },
            handleVal(val){
                this.allval = val;
            },
            /*
             * 薪资结构选择
             * @param name {string} 薪资结构name
             **/
            workTypeSel(name){
                let index = this.workType.findIndex(_j => _j === name);
                if (index > -1) {
                    this.workType.splice(index, 1);
                    return;
                }
                if (this.workType.length == 3) {
                    this.workTypeMore = true;
                    setTimeout(()=>{
                        this.workTypeMore = false;
                    },2000)
                    return;
                }
                this.workType.push(name);
            },
            /*
             * 有无宿舍
             * @param name {number} 0无 1有
             * */
            provideBedroomSel(name){
                this.provideBedroom = name;
            },
            /*
             * 有无餐厅
             * @param name {number} 0五餐厅 1有餐厅
             * */
            provideDiningroomSel(name){
                this.provideDiningroom = name;
            },
            // 福利选择
            welfareSel(name){
                let index = this.welfareSelList.findIndex(_j => _j === name);
                if (index > -1) {
                    this.welfareSelList.splice(index, 1);
                    return;
                }
                if(this.welfareSelList.length == 4){
                    this.welfareMore = true;
                    setTimeout(()=>{
                        this.welfareMore = false;
                    },2000)
                    return;
                }
                this.welfareSelList.push(name);
            },
            getWelfareList(){
                this.axios.get('/wapi/company/listWelfare')
                    .then(res => {
                        this.welfareList = res.data;
                    })
            },
            getListEducation(){
                this.axios.get('/wapi/baseData/listEducation')
                    .then(res => {
                        if (res.status * 1 === 200) {
                            this.eduList = res.data;
                        }
                    })
            },
            // 查询企业类别一级分类
            getListIndustry(){
                this.axios.get('/wapi/baseData/listIndustry')
                    .then(res => {
                        this.industryList = res.data.map((item, index, arr) => {
                            item.value = item.id + '-' + item.name + '-' + index;
                            item.label = item.name;
                            item.children = [];
                            return item;
                        });
                    })
            },
            //查询企业类别二级分类
            getListClassify(id){
                this.axios.get('/wapi/baseData/listClassify?industryId=' + id)
                    .then(res => {
                        this.classifyList = res.data.map((item, index, arr) => {
                            item.value = item.id + '-' + item.name + '-' + index;
                            item.label = item.name
                            item.children = [];
                            return item;
                        });
                        this.industryList[this.industryIdIndex].children = this.classifyList;
                    })
            },
            //查询企业类别三级分类
            getListPosition(id){
                this.axios.get('/wapi/baseData/listPosition?classifyId=' + id)
                    .then(res => {
                        this.industryList[this.industryIdIndex].children[this.classifyIndex].children = res.data.map((item, index, arr) => {
                            item.label = item.name;
                            item.value = item.id + '-' + item.name + '-' + index;
                            return item;
                        });
                    })
            },
            getListExperience(){
                let url = '/wapi/baseData/listExperience';
                this.axios.get(url).then(res => {
                    this.expList = res.data;
                })
            },
            handleItemChange(val){
                if (val[0]) {
                    this.industryId = val[0];
                }
                if (val[1]) {
                    this.classifyId = val[1];
                }
                if (val[2]) {
                    this.positionId = val[2]
                }
            },
            // 获取hr列表
            getHrList(){
                let url = '/wapi/hr/list';
                this.axios.get(url)
                    .then(res => {
                        this.hrList = res.data;
                        let hrsObj = this.hrList.find((item, val, arr) => item.hrName == this.$store.getters.hrname);
                        this.hrs = hrsObj.hrId + '-' + hrsObj.hrName ;
                    })
            },
            verifiy(){
                if(this.title.length == 0){
                    Message({
                        message:"请输入岗位名称",
                        type:'warning'
                    });
                    return;
                }
                if(this.title.length < 2){
                    Message({
                        message:"岗位名称过短",
                        type:'warning'
                    });
                    return;
                }
                if(!isNaN(this.title)){
                    Message({
                        message:"岗位名称不能纯数字",
                        type:'warning'
                    });
                    return;
                }
                if(this.allval.length < 3){
                    Message({
                        message:"请选择分类",
                        type:'warning'
                    });
                    return;
                }
                if(this.requireMinage*1 < 0 || this.requireMaxage*1 < 0){
                    Message({
                        message:"年龄要求不能小于0",
                        type:'warning'
                    });
                    return;
                }
                if(isNaN(this.requireMinage) || isNaN(this.requireMaxage)){
                    Message({
                        message:"填写的年龄要求格式不对",
                        type:'warning'
                    });
                    return;
                }
                if(this.requireMinage.length == 0 || this.requireMaxage.length == 0){
                    Message({
                        message:"请填写最大年龄要求和最小年龄要求",
                        type:'warning'
                    });
                    return;
                }
                if(this.requireMinage > this.requireMaxage){
                    Message({
                        message:"最小年龄不能大于最大年龄",
                        type:'warning'
                    });
                    return;
                }

                if(this.workType.length == 0){
                    Message({
                        message:"请选择薪资结构",
                        type:'warning'
                    });
                    return;
                }
                if (this.minSalary.length == 0 || this.maxSalary.length == 0) {
                    Message({
                        message: "请填写薪资范围",
                        type: 'warning'
                    });
                    return;
                }
                if (isNaN(this.minSalary) || isNaN(this.maxSalary)) {
                    Message({
                        message: "薪资范围格式不对",
                        type: 'warning'
                    });
                    return;
                }
                if (this.minSalary < 0 || this.maxSalary < 0) {
                    Message({
                        message: "薪资要求不能为小于0",
                        type: 'warning'
                    })
                    return;
                }
                console.log(this.minSalary,this.maxSalary)
                if (this.minSalary*1 > this.maxSalary*1) {
                    Message({
                        message: "最小薪资不能大于最大薪资",
                        type: 'warning'
                    })
                    return;
                }
                if (this.recruitNumber.length == 0 || isNaN(this.recruitNumber) || this.recruitNumber < 0) {
                    Message({
                        message: "请填写招聘人数",
                        type: 'warning'
                    })
                    return;
                }
                if (!this.workStartTime || !this.workEndTime || !this.workHours) {
                    Message({
                        message: "请填写工作时间",
                        type: 'warning'
                    })
                    return;
                }
                if (this.hrs == -1) {
                    Message({
                        message: "请选择发布人",
                        type: 'warning'
                    });
                    return;
                }

                return true;
            },
            uploadVideo (event) {
                let formdata = new FormData();
                const file = event.target.files[0];
                console.log('file: ', file)
                if (file.size / 1024 > 25 * 1000){
                    Message({
                        message: "视频不能大于25M",
                        type: 'warning'
                    })
                    return
                }else if (file.type.indexOf('video/') < 0) {
                     Message({
                        message: "请上传视频",
                        type: 'warning'
                    })
                    return
                }

                formdata.append('file',event.target.files[0]);
                this.axios.post('/wapi/base/upload',formdata).then(res => {
                    if(res.status*1 == 200){

                        // this.axios.get(`/wapi/hr/modifyHeadImage?headImage=${res.data}`).then( kres => {
                        //     this.$store.commit('hrChnageImg',res.data);
                        //     if(kres.status){
                        //         this.$message({
                        //             type:'success',
                        //             message:'上传成功'
                        //         })
                        //     }
                        // })
                        this.recruitVideo = res.data
                    }
                })
            },
            showVideo () {
                this.videoVisible = true;
            },
            //立即发布
            publish(save){

                if (!this.verifiy()) {
                    return;
                }
                let [industry, classify, position] = this.allval;
                let qdata = {
                    title: this.title,
                    category: this.category,

                    requireClothing: this.requireClothing,
                    requireImage: this.requireImage,
                    requireHeight: this.requireHeight,

                    industryId: industry.split("-")[0],
                    industryName: industry.split("-")[1],
                    classifyId: classify.split("-")[0],
                    classifyName: classify.split("-")[1],
                    positionId: position.split("-")[0],
                    positionName: position.split("-")[1],
                    description: this.description,
                    requireSex: this.requireSex,
                    hrId: this.hrs.split('-')[0],
                    hrName: this.hrs.split('-')[1],
                    requireMinage: this.requireMinage, // 需求最小年龄
                    requireMaxage: this.requireMaxage, // 需求最大年龄
                    requireExp: this.requireExp, // 需求经验
                    requireEdu: this.requireEdu, // 需求学历
                    minSalary: this.minSalary, // 最小薪资
                    maxSalary: this.maxSalary, //最大薪资
                    recruitNumber: this.recruitNumber, //需求人数
                    welfare: this.welfareSelList, //福利要求
                    workStartTime: this.workStartTime +':00',
                    workEndTime: this.workEndTime+':00',
                    workHours: this.workHours,
                    dayOffLength: this.dayOffLength, //月休天数
                    provideCarsubsidy: this.switchCheck ? 1 : 0, // 面试车车补
                    carsubsidy: this.switchCheck ? this.carsubsidy : 0, // 路费补贴
                    workType: this.workType, //薪资结构
                    provideBedroom: this.provideBedroom, // 有无宿舍
                    provideRestsubsidy: this.provideRestsubsidy,// 住宿补贴类型
                    provideDiningroom: this.provideDiningroom,// 有无餐厅
                    provideFood: this.provideFood,
                    recruitVideo: this.recruitVideo,
                    keywords: this.skilList,
                };

                // 用餐补贴
                if (qdata.provideFood == 2) {
                    qdata.foodsubsidy = this.foodsubsidy
                } else {
                    qdata.foodsubsidy = 0;
                }

                let yuan = 0;
                if (qdata.provideRestsubsidy == 2) {
                    yuan = this.restsubsidys.bufen?this.restsubsidys.bufen :0
                } else if (qdata.provideRestsubsidy == 3) {
                    yuan = this.restsubsidys.waizhu?this.restsubsidys.waizhu : 0
                } else {

                }
                qdata.restsubsidy = yuan;
                let url = '/wapi/hr/recruit/cPublish';
                if (this.tabindex === 1) {
                    url = '/wapi/hr/recruit/mPublish'
                    qdata.recruitId = this.cuid;
                }
                if (save) {
                    url = '/wapi/hr/recruit/cSave'
                }
                //确认按钮
                this.$confirm('确认将岗位 '+this.title+' ' + (!save ?  '发布到' : '保存到') + '平台吗？','',{
                                confirmButtonText: '是的',
                                cancelButtonText:"取消"
                            }).then(()=>{
                                this.loadingObj = this.$loading();
                                this.axios.post(url,  qs.stringify(qdata))
                                    .then(res => {
                                        setTimeout(()=>{
                                            this.loadingObj.close();
                                        })
                                        if (res.success) {
                                            Message({
                                                message: res.msg
                                            });
                                            setTimeout(() => {
                                                this.$router.push('/index/posts/list')
                                            }, 2000)
                                        }
                                    })
                            })

            },
            getSkillList() {
                this.axios.get(`/wapi/baseData/listKeywords?keyword=${this.currentAddSkil}`)
                    .then(({status, data}) => {
                        if (status === 200 && data.length) {
                            this.skilTree = data
                        }
                    })
            },
            getPostInfo() {
                if (!this.allval.length || !this.title) {
                    this.$message({
                        message: '请先输入岗位名称和岗位类别',
                        type: 'warning'
                    })
                    return
                }
                this.aiReleast = true
                this.btnText = '再次生成'
                this.postDesc = null
                this.postSkils = []

                const params1 = {
                    "inputs": {
                        "title": this.title, // 岗位标题
                        "classifyName": this.allval[0], // 岗位分类
                        "positionName": this.allval[2] // 岗位名称
                    },
                    // "response_mode": "streaming",
                    "user": "ztx-wapi"
                }

                const currentEnvir = 'pro'
                const { url: aiUrl, auth: { desc, keyword } } = AI_INFO[currentEnvir]

                // 岗位描述生成
                this.axios.post(aiUrl, params1, {
                    headers: { Authorization: desc }
                }).then(res => {
                    if (!res.answer) return
                    this.cDescription = res.answer.replace('/\n', '')
                    const _answer = res.answer.split('\n')
                    let _html = ''
                    _answer.forEach(f => { //
                        _html += `<div>${f}</div></br>`
                    })
                    this.postDesc = _html

                    const params2 = {
                        "inputs": {
                            "title": this.title, // 岗位标题
                            "description": res.answer // 岗位描述
                        },
                        // "response_mode": "streaming",
                        "user": "ztx-wapi"
                    }
                    // 提取关键词
                    this.axios.post(aiUrl, params2, {
                        headers: { Authorization: keyword }
                    }).then(res2 => {
                        if (!res2.answer) return
                        let regex = /<keyword>(.*?)<\/keyword>/g
                        let matches = [...res2.answer.matchAll(regex)]
                        this.postSkils = matches.map(match => match[1])
                    })
                })
            },
            handleDelTag(index) {
                this.skilList.splice(index, 1)
            },
            handleAddSkil(sk) {
                this._addSkil(sk)
            },
            handleRefreshInfo() {

            },
            handleBatchAddSkil() {
                this.description = this.cDescription
                this.postSkils.forEach(f => {
                    this._addSkil(f)
                })
            },
            handleEnter(event) {
                console.log(event)
                if (event.keyCode !== 13) return
                this._addSkil(this.currentAddSkil)
                this.currentAddSkil = ''
            },
            handleChange() {
                this.getSkillList()
                console.log('this.currentAddSkil--', this.currentAddSkil)
            },
            _addSkil(val) {
                if (this.skilList.includes(val)) return
                this.skilList.push(val)
            }
        },
        mounted() {
            this.$refs.skilInputRef.$el.addEventListener('keydown', this.handleEnter)
        }
    }
</script>
<style scoped lang="less">
    @import url(../../assets/less/base.less);
    @import "../../assets/css/station";
    .publish-boxs {
        padding: 22px 24px !important;
        border-radius: 10px;
        .box-title {
            font-weight: bold;
            font-size: 22px;
            color: #141414;
            line-height: 30px;
            margin-bottom: 10px;
            .sub {
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                line-height: 22px;
                text-align: left;
                font-style: normal;
            }
        }
    }
    .f-w {
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
    }
    .textarea-box{
        border: 1px solid #E6E6E6;
        background-color: transparent;
        line-height: 40px;
        textarea{
             height: 100%;
             line-height: 40px;
        }
    }
    .recommend-box{
        width: 326px;
        height: 200px;
        background: #E5F2FF;
        border-radius: 4px;
        padding: 15px 20px;
        box-sizing: border-box;
        margin-left: 20px;
        .in-title{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC, 'Microsoft Yahei', '微软雅黑', Sans-serif;
            font-weight: 500;
            color: #057CF9;
            line-height: 22px;
            margin-bottom: 15px;
        }
        .text-area{
            height: 98px;
            margin-bottom: 11px;
        }
        .button{
            width: 80px;
            height: 28px;
            background: #5BB0FF;
            border-radius: 4px;
            text-align: center;
            line-height: 28px;
            font-size: 16px;
            color: #FFFFFF;
        }
    }
    .skil-box {
        align-items: flex-start !important;
        flex-direction: column;
        .title-2 {
            margin-top: 16px;
            font-size: 16px;
            color: rgba(51, 51, 51, 1);
        }
        .tag-box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 8px;
            margin-bottom: 28px;
            .el-tag {
                margin-right: 8px;
                margin-bottom: 8px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .skil-title {
            font-size: 16px;
            color: #333333;
            line-height: 22px;
            margin-top: 16px;
        }
        .skil-item {
            color: rgba(109, 114, 120, 1);
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            span {
                padding: 6px 12px;
                margin-top: 8px;
                margin-right: 8px;
                background-color: rgba(245, 247, 251, 1);
                cursor: pointer;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
    .new-recommend-box {
        position: relative;
        width: 400px;
        max-height: 536px;
        background: linear-gradient( 180deg, #057CF9 0%, rgba(5,124,249,0) 100%);
        border-radius: 8px;
        margin-left: 20px;
        padding: 47px 8px;
        .robote {
            position: absolute;
            width: 110px;
            height: 110px;
            top: -27px;
        }
        .content-box {
            background: #F6FAFF;
            border-radius: 8px;
            backdrop-filter: blur(10px);
            margin-bottom: 10px;
            font-size: 14px;
            color: rgba(109, 114, 120, 1);
            padding: 14px 20px;
            .a-b {
                max-height: 377px;
                overflow: auto;
            }
            .split-line {
                height: 1px;
                border-top: 1px dashed #E6E6E6;
                margin: 35px 0 8px 0;
            }
            .sub-tit {
                color: rgba(51, 51, 51, 1);
                margin-bottom: 8px;
            }
            .label-item {
                color: rgba(51, 51, 51, 1);
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                span {
                    padding: 2px 12px;
                    margin-right: 9px;
                    background-color: rgba(240, 240, 241, 1);
                    margin-bottom: 5px;
                }
            }
        }
        .btns-box {
            display: flex;
            align-items: center;
            span {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 120px;
                height: 32px;
                border-radius: 4px;
                margin-right: 12px;
                cursor: pointer;
            }
            .refresh {
                color: rgba(51, 51, 51, 1);
                background-color: rgba(255, 255, 255, 1);
                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 4px;
                }
            }
            .submit {
                background: #057CF9;
                color: rgba(255, 255, 255, 1);
            }
        }
    }
    .item{
        margin-bottom: 16px;
        font-size: 16px;
        color: #333333;
        .flex;
        .label{
            width: 125px;
            display: flex;
            line-height: 40px;
            justify-content: flex-end;
            align-items: flex-start;
            margin-right: 24px;
            &.require{
                &::before{
                    content: '*';
                    color: #E91414;
                    display: block;
                    font-size: 18px;
                    margin-right: 10px;
                }
            }
        }
        .value{
            .flex;
        }
        .input-box{
            height: 40px;
            border-radius: 4px;
            border: 1px solid #E6E6E6;
            background: transparent;
            width: 220px;;
            &.min{
                width: 128px;
            }
        }
        .one-input{
            width: 220px;
        }
    }
    .el-input__inner {
        border: none;
    }

    .publish-boxs .lishbtn-groups-ks {
        flex-wrap: wrap;
        width: 800px;
    }

    .publish-boxs .lishbtn-groups-ks .button {
        margin-bottom: 10px;
    }

    .publish-boxs .lishadd {
        margin-top: 10px;
    }
    .errorTs{
        color: #e60b0b;
        float: left;
        font-size:12px;
        margin:6px 0 0 12px;
    }
</style>



// WEBPACK FOOTER //
// release.vue?300bf752